import * as Yup from 'yup'

export const connectIntegrationSchema = Yup.object().shape({
  secretToken: Yup.string().required('errors.validation.secretToken.required'),
})

export const saveRuleSchema = Yup.object().shape({
  products: Yup.array().min(1),
  offers: Yup.array().min(1),
})

export const ruleSchema = ['products', 'offers']
export const connectSchema = ['secretToken']
